export const FETCH_COURSE_ADMIN_DATA_START = 'FETCH_COURSE_ADMIN_DATA_START';
export const FETCH_COURSE_ADMIN_DATA_SUCCESS =
  'FETCH_COURSE_ADMIN_DATA_SUCCESS';
export const FETCH_COURSE_ADMIN_DATA_FAILURE =
  'FETCH_COURSE_ADMIN_DATA_FAILURE';

export const FETCH_COURSE_LANDING_PAGE_DATA_START =
  'FETCH_COURSE_LANDING_PAGE_DATA_START';
export const FETCH_COURSE_LANDING_PAGE_DATA_SUCCESS =
  'FETCH_COURSE_LANDING_PAGE_DATA_SUCCESS';
export const FETCH_COURSE_LANDING_PAGE_DATA_FAILURE =
  'FETCH_COURSE_LANDING_PAGE_DATA_FAILURE';
export const ADD_COURSE_LANDING_PAGE_TEAM_MEMBER =
  'ADD_COURSE_LANDING_PAGE_TEAM_MEMBER';
export const REMOVE_COURSE_LANDING_PAGE_TEAM_MEMBER =
  'REMOVE_COURSE_LANDING_PAGE_TEAM_MEMBER';
export const UPDATE_COURSE_LANDING_PAGE_MEDIA =
  'UPDATE_COURSE_LANDING_PAGE_MEDIA';
export const UPDATE_COURSE_LANDING_PAGE_BLURB =
  'UPDATE_COURSE_LANDING_PAGE_BLURB';
export const UPDATE_COURSE_LANDING_PAGE_OUTCOMES_SUMMARY =
  'UPDATE_COURSE_LANDING_PAGE_OUTCOMES_SUMMARY';
export const UPDATE_COURSE_LANDING_PAGE_INTRODUCTION =
  'UPDATE_COURSE_LANDING_PAGE_INTRODUCTION';
export const UPDATE_COURSE_LANDING_PAGE_FURTHER_INFORMATION =
  'UPDATE_COURSE_LANDING_PAGE_FURTHER_INFORMATION';
export const UPDATE_COURSE_LANDING_PAGE_CPD_HOURS =
  'UPDATE_COURSE_LANDING_PAGE_CPD_HOURS';
export const TOGGLE_COURSE_LANDING_PAGE_HIDE_COST =
  'TOGGLE_COURSE_LANDING_PAGE_HIDE_COST';
export const UPDATE_COURSE_LANDING_DEFAULT_COHORT =
  'UPDATE_COURSE_LANDING_DEFAULT_COHORT';
export const SAVE_COURSE_LANDING_PAGE_START = 'SAVE_COURSE_LANDING_PAGE_START';
export const SAVE_COURSE_LANDING_PAGE_SUCCESS =
  'SAVE_COURSE_LANDING_PAGE_SUCCESS';
export const SAVE_COURSE_LANDING_PAGE_FAILURE =
  'SAVE_COURSE_LANDING_PAGE_FAILURE';

export const COPY_COURSE_START = 'COPY_COURSE_START';
export const COPY_COURSE_SUCCESS = 'COPY_COURSE_SUCCESS';
export const COPY_COURSE_FAILURE = 'COPY_COURSE_FAILURE';
export const HIDE_COPY_COURSE_SUCCESS_MODAL = 'HIDE_COPY_COURSE_SUCCESS_MODAL';
export const HIDE_COPY_COURSE_ERROR_MODAL = 'HIDE_COPY_COURSE_ERROR_MODAL';

export const FETCH_COURSE_ROLES_DATA_START = 'FETCH_COURSE_ROLES_DATA_START';
export const FETCH_COURSE_ROLES_DATA_SUCCESS =
  'FETCH_COURSE_ROLES_DATA_SUCCESS';
export const FETCH_COURSE_ROLES_DATA_FAILURE =
  'FETCH_COURSE_ROLES_DATA_FAILURE';

export const FETCH_CERTIFICATION_SETUP_DATA_START =
  'FETCH_CERTIFICATION_SETUP_DATA_START';
export const FETCH_CERTIFICATION_SETUP_DATA_SUCCESS =
  'FETCH_CERTIFICATION_SETUP_DATA_SUCCESS';
export const FETCH_CERTIFICATION_SETUP_DATA_FAILURE =
  'FETCH_CERTIFICATION_SETUP_DATA_FAILURE';

export const UPDATE_CERTIFICATION_TYPE = 'UPDATE_CERTIFICATION_TYPE';
export const UPDATE_CERTIFICATION_CODE = 'UPDATE_CERTIFICATION_CODE';
export const UPDATE_CERTIFICATION_DATA = 'UPDATE_CERTIFICATION_DATA';

export const SAVE_CERTIFICATION_START = 'SAVE_CERTIFICATION_START';
export const SAVE_CERTIFICATION_SUCCESS = 'SAVE_CERTIFICATION_SUCCESS';
export const SAVE_CERTIFICATION_FAILURE = 'SAVE_CERTIFICATION_FAILURE';

export const FETCH_ACCREDIBLE_DESIGNS_START = 'FETCH_ACCREDIBLE_DESIGNS_START';
export const FETCH_ACCREDIBLE_DESIGNS_SUCCESS =
  'FETCH_ACCREDIBLE_DESIGNS_SUCCESS';
export const FETCH_ACCREDIBLE_DESIGNS_FAILURE =
  'FETCH_ACCREDIBLE_DESIGNS_FAILURE';

export const GET_COURSE_STRIPE_CONNECT_CONTEXT_START =
  'GET_COURSE_STRIPE_CONNECT_CONTEXT_START';
export const GET_COURSE_STRIPE_CONNECT_CONTEXT_SUCCESS =
  'GET_COURSE_STRIPE_CONNECT_CONTEXT_SUCCESS';
export const GET_COURSE_STRIPE_CONNECT_CONTEXT_FAILURE =
  'GET_COURSE_STRIPE_CONNECT_CONTEXT_FAILURE';
